import Component from '@glimmer/component';
import { localCopy } from 'tracked-toolbox';

export default class VideoEmbed extends Component {
  @localCopy('args.showModal', false) showModal;
}
